module.exports = __webpack_public_path__ + "static/media/waving_hand_sign_512.9b891f92.gif";